import * as React from 'react';
import {useDispatch} from 'react-redux';
import * as reduxApi from 'src/utils/redux-api-v2';

import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';


const GetCompletedInterviewData = ({
  stepCandidateId,
  children,
  loaderComponent,
}: {
  stepCandidateId: number;
  children: React.ReactNode;
  loaderComponent?: React.ReactNode;
}) => {
  const dispatch = useDispatch();
  const [completedInterviewData, setCompletedInterviewData] =
    React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!completedInterviewData) {
      setLoading(true);
      dispatch(
        reduxApi.get(
          `api/interview-candidates/${stepCandidateId}`,
          {},
          {
            apiPath: '/trmapi/',
          },
        ),
      )
        .then((res) => {
          setCompletedInterviewData(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [stepCandidateId]);

  if (loading) {
    return loaderComponent ? loaderComponent : <CircularLoader />;
  }

  if (!completedInterviewData && !loading) {
    return null;
  }

  // @ts-expect-error - TS2349 - This expression is not callable. | TS2723 - Cannot invoke an object which is possibly 'null' or 'undefined'.
  return children(completedInterviewData);
};

export default GetCompletedInterviewData;
